import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  fillCheckbox: [],
  fillSelectBooks: [],
  filterBooksItems: [],
  userNumber: "",
  userEmail: 0,
  freeSales: 0,
  items: [],
};
const initialState1 = {
  author: "",
  publisher: "",
  visibleToUser: "",
  availableToUser: "",
  comboOffer: "",
  category: "",
  course: "",
  subject: "",
  medium: "",
  seriesTag: "",
  eBook: "",
  searchTerm: "",
  freeBook: "",
  paymentMode: "",
  deliveryMode: "",
  deliveryStatus: "",
  branchLocation: "",
  enrollStudent: "",
  date: "",
  Fill_price: "",
  activeTab: "",
  weight: "",
  totalPrice: "",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.userNumber = action.payload.userNumber;
      state.userEmail = action.payload.userEmail;
      state.freeSales = action.payload.freeSales;
      state.fillCheckbox = action.payload.fillCheckbox;
      state.fillSelectBooks = action.payload.fillSelectBooks;
      state.filterBooksItems = action.payload.filterBooksItems;
      state.items = action.payload.items;
    },
    resetSetFilters: (state, action) => {
      state.fillCheckbox = [];
      state.fillSelectBooks = [];
      state.filterBooksItems = [];
      state.userNumber = [];
      state.userEmail = "";
      state.freeSales = 0;
      state.items = [];
    },
  },
});
const ListBookFilterSlice = createSlice({
  name: "ListBookFilter",
  initialState: initialState1,
  reducers: {
    setBookFilters: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearBookFilters: () => initialState1,
  },
});
export const { setFilters, resetSetFilters } = filterSlice.actions;
export const { setBookFilters, clearBookFilters } = ListBookFilterSlice.actions;
export const filterReducer = filterSlice.reducer;
export const listBookFilterReducer = ListBookFilterSlice.reducer;
